import React from "react";
import linkedin from "../../assets/utility_images/linkedin-ceo.svg";
import linkedinleader from "../../assets/utility_images/linkedin-leader.svg";

import "./LeaderCard.css";

const LeaderCard = ({background,heading,description,role,externalUrl}) => {
  return (
    <div className="leader-card d-flex flex-column align-items-center">
      <div className="leader-photo">
        <img src={background} alt="" loading="lazy" />
      </div>
      <div className="leader-name">{heading}</div>
      <div className="leader-company">{role}</div>
      <div className="leader-experience">{description}</div>
      <a href={externalUrl} target="_blank" rel="noreferrer">
        <div className="linkedin">
          <img
            className="hover-linkedin"
            src={linkedinleader}
            alt=""
            loading="lazy"
          />
          <img
            className="after-hover-linkedin"
            src={linkedin}
            alt=""
            loading="lazy"
          />
        </div>
      </a>
    </div>
  );
};

export default LeaderCard;
